import type { Channel, ContactType, SendState } from "./compose.types.ts"

export type ConsentState = "allowed" | "stopped" | "unsubscribed"

export const CHANNEL_REFUSAL: Record<Channel, ConsentState> = {
  email: "unsubscribed",
  sms: "stopped"
}

export interface ConsentEvent {
  id: string
  channel: Channel
  field: string
  from_value: string
  to_value: string
  source: string
  recorded_by_name: string | null
  reason: string
  stated_on: string | null
  occurred_at: string
}

export interface ContactConsent extends SendState {
  history: ConsentEvent[]
}

export interface ConsentChange {
  channel: Channel
  state: ConsentState
  reason: string
  date: string
}

export interface OptOutRow {
  id: string
  channel: Channel
  contact_kind: ContactType
  contact_id: string | null
  contact_name: string
  /** Whether the reader may open the contact's own page; the row is listed either way. */
  contact_visible?: boolean
  address_snapshot: string
  state: ConsentState
  state_source: string
  state_reason: string
  state_changed_at: string | null
  recorded_by_name: string | null
}

/** Opt-outs are one per contact and channel; `contacts` counts the people behind them. */
export interface OptOutSummary {
  count: number
  contacts: number
}
